import { render } from "./D3Tree.vue?vue&type=template&id=6163be8e&scoped=true"
import script from "./D3Tree.vue?vue&type=script&lang=js"
export * from "./D3Tree.vue?vue&type=script&lang=js"

import "./D3Tree.vue?vue&type=style&index=0&id=6163be8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6163be8e"]])

export default __exports__